<template>
  <div class="toasts">
    <div class="sidebar" :class="toast.type"></div>
    <div class="content">
      <div class="header">
        <h3>{{ toast.title }}</h3>
        <button @click="dismissToast">X</button>
      </div>
      <div class="text">
        <p>{{ toast.message }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Toast',
  props: {
    toast: { required: true, type: Object }
  },
  created () {
    // Automatically dismiss toast after 5 seconds
    setTimeout(() => {
      this.dismissToast()
    }, 4000)
  },
  methods: {
    dismissToast () {
      this.$store.commit('clearToast', this.toast.title)
    }
  }
}
</script>
<style scoped>
.success, .info, .error {
  color:#FFFFFF;
}

.success {
  background-color: #009900;
}

.info {
  background-color: #009999;
}

.error {
  background-color: #990000;
}

.toasts {
  min-height: 50px;
  display: flex;
  flex-direction: row;
  margin-bottom: 1rem;
  padding: 1rem;
  box-sizing: border-box;
  background-color: var(--bs-body-bg);
  color: var(--bs-body-color);
  justify-content: center;
  border-top-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  border-top-right-radius: 1rem;
  box-shadow: 0 0 1rem var(--bs-secondary-bg);
  border: 1px solid var(--bs-border-color);
  /* Add these properties */
  position: fixed; /* Keeps toast visible even when scrolling */
  z-index: 1000;  /* Ensures it appears above other elements */
}

/* Rest of your CSS remains unchanged */
.toasts p {
  font-weight: 100;
}

.toasts .sidebar {
  width: 1rem;
}

.toasts .content,
.toasts .header,
.toasts .text {
  width: 100%;
  display: flex;
}

.toasts .content {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 1rem;
  box-sizing: border-box;
}

.toasts .header,
.toasts .text {
  flex-direction: row;
  justify-content: flex-start;
  text-align: left;
}

.toasts .header {
  height: 25px;
  margin-bottom: 1rem;
}

.toasts .header button {
  margin-left: auto;
  text-decoration: none;
  border: none;
  cursor: pointer;
  background: none;
  color: var(--bs-body-color);
  font-size: 1rem;
}

.toasts .header button:hover {
  background: var(--bs-tertiary-bg);
}

.toasts .content {
  flex-grow: 1;
}

</style>



// WEBPACK FOOTER //
// src/components/toast/Toast.vue